import { render, staticRenderFns } from "./SignupPackagesSummary.vue?vue&type=template&id=4322aa86"
import script from "./SignupPackagesSummary.vue?vue&type=script&lang=js"
export * from "./SignupPackagesSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports